export function inIFrame(window) {
  try {
    return window.self !== window.top;
  } catch (err) {
    return true;
  }
}
